import React, { useEffect, useState } from 'react';

const EvaluationPlanWebDocumentTemplateNameModal: React.FC<{
  open: boolean;
  mode: 'save' | 'rename';
  initialName?: string;
  error?: string | null;
  onClose: () => void;
  onSubmit: (name: string) => void;
}> = ({ open, mode, initialName = '', error = null, onClose, onSubmit }) => {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (!open) return;
    setName(initialName);
  }, [open, initialName]);

  if (!open) return null;

  const title = mode === 'save' ? '기준안 양식 저장' : '양식 이름 수정';

  return (
    <div
      className="cp-modal-backdrop cp-evaluation-plan-web-doc-template-name-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="cp-modal cp-evaluation-plan-web-doc-template-name-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-evaluation-plan-web-doc-template-name-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="cp-evaluation-plan-web-doc-template-name-title">{title}</h3>
        <div className="cp-modal-body">
          <label className="cp-evaluation-plan-web-doc-template-name-label" htmlFor="cp-evaluation-plan-web-doc-template-name-input">
            양식 이름
          </label>
          <input
            id="cp-evaluation-plan-web-doc-template-name-input"
            type="text"
            className="cp-evaluation-plan-web-doc-template-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="양식 이름을 입력하세요"
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter') onSubmit(name);
            }}
          />
          {error ? <p className="cp-evaluation-plan-web-doc-template-name-error">{error}</p> : null}
        </div>
        <div className="cp-modal-footer">
          <button type="button" className="cp-btn-secondary" onClick={onClose}>
            취소
          </button>
          <button type="button" className="cp-btn-primary" onClick={() => onSubmit(name)}>
            {mode === 'save' ? '저장' : '수정'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EvaluationPlanWebDocumentTemplateNameModal;
